<template>
    <div class="card-body">
        <div class="form">
            <div class="col-12">
                <label for="imagen">Imagen simpatizantes:</label>
                <p>
                    <small>
                        MEDIDAS: 1000X1200 - FORMATO: JPG - PESO MÁXIMO: Menos de 500 KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.bg1_url">
                    <img :src="manager.bg1_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('bg1')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="1200"
                        :width="1000"
                        @success="imagenSubida('bg1', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <label for="imagen">Imagen renovación:</label>
                <p>
                    <small>
                        MEDIDAS: 960x517 - FORMATO: JPG - PNG - PESO MÁXIMO: Menos de 500 KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.bg2_url">
                    <img :src="manager.bg2_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('bg2')">Borrar</Button>
                </template>
                <template v-else>                                    
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="517"
                        :width="960"
                        @success="imagenSubida('bg2', ...arguments)"
                    />
                </template>                                
            </div>
            <hr/>
            <div class="col-12">
                <label for="imagen">Imagen principal:</label>
                <p>
                    <small>
                        MEDIDAS: 2000X1500 - FORMATO: JPG - PNG - PESO MÁXIMO: Menos de 500 KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.bg3_url">
                    <img :src="manager.bg3_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('bg3')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="1500"
                        :width="2000"
                        @success="imagenSubida('bg3', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <label for="imagen">Imagen login:</label>
                <p>
                    <small>
                        MEDIDAS: 2000X1500 - FORMATO: JPG - PNG - PESO MÁXIMO: Menos de 500 KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.bg4_url">
                    <img :src="manager.bg4_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('bg4')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="1500"
                        :width="2000"
                        @success="imagenSubida('bg4', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <Button @click="guardarOpciones">Guardar</Button>
            </div>
        </div>
    </div>
</template>

<script>
    import Dropzone from '@/components/common/Dropzone';

    export default {
        props: ['manager'],
        data() {
            return {
                url: this.config.API_BASE + '/upload/image?permisos=public&api_key=' + localStorage.getItem('token'),
                managerLocal: this.manager
            }
        },
        methods: {
            guardarOpciones() {
                this.$emit('guardar', this.managerLocal);
            },
            imagenBorrada(campo) {
                switch (campo) {
                    case 'bg1':
                        this.managerLocal.bg1 = null;
                        this.managerLocal.bg1_url = null;
                        break;
                    case 'bg2':
                        this.managerLocal.bg2 = null;
                        this.managerLocal.bg2_url = null;
                        break;
                    case 'bg3':
                        this.managerLocal.bg3 = null;
                        this.managerLocal.bg3_url = null;
                        break;
                    case 'bg4':
                        this.managerLocal.bg4 = null;
                        this.managerLocal.bg4_url = null;
                        break;
                }
            },
            imagenSubida(campo, file, response) {
                switch (campo) {
                    case 'bg1':
                        this.managerLocal.bg1 = response;
                        break;
                    case 'bg2':
                        this.managerLocal.bg2 = response;
                        break;
                    case 'bg3':
                        this.managerLocal.bg3 = response;
                        break;
                    case 'bg4':
                        this.managerLocal.bg4 = response;
                        break;
                }
            }
        },
        components: {
            Dropzone
        }
    }
</script>
